import constants from "../../../../../../../../appConstants";
import {
  MultiSelectFilter,
  StaticFilter,
} from "../../../../../../../dataGrid/columnFilters";
import { HZ_FILTER } from "../../../../constants";
import { SpecialNeedsRenderer } from "../../../../../../../dataGrid/cellRenderer/index";
import { svcValueGetter, hazmatValueGetter } from "../../../../../../../dataGrid/gridUtilities";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }
  static proIdValueGetter(props) {
    return props.data?.proId !== "0"
      ? props.data.proId
      : "";
  }

  static getDefaultConfiguration() {
    return {
      title: constants.gridNames.DispatchPickupInfoGrid,
      keyColumn: "",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Seq#",
          headerTooltip: "Sequence Number",
          field: "",
          valueGetter: (params) =>
            `${params.node.rowIndex + 1}`.padStart(3, "0"),
          minWidth: constants.columnWidth.W_85,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          lockPosition: true,
        },
        {
          headerName: "Dest Zip",
          headerTooltip: "Destination Zip",
          field: "consigneeZip",
          minWidth: constants.columnWidth.W_95,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          lockPosition: true,
        },
        {
          headerName: "Dest Term",
          headerTooltip: "Destination Terminal",
          minWidth: constants.columnWidth.W_110,
          field: "destinationTerminal",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          lockPosition: true,
        },
        {
          headerName: "HU",
          headerTooltip: "Handling Unit",
          field: "hu",
          minWidth: constants.columnWidth.HU,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          lockPosition: true,
        },
        {
          headerName: "Pieces",
          field: "pieces",
          minWidth: constants.columnWidth.W_85,
          lockPosition: true,
          headerTooltip: "Pieces",
          filterFramework: MultiSelectFilter,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Weight",
          field: "weight",
          minWidth: constants.columnWidth.W_90,
          lockPosition: true,
          headerTooltip: "Total weight",
          cellClass: "gridCell-centerAlign",
          filterFramework: MultiSelectFilter,
        },

        {
          headerName: "Pkg Code",
          field: "packageCode",
          headerTooltip: "Package Code",
          minWidth: constants.columnWidth.W_95,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Hz",
          headerTooltip: "Hazard",
          valueGetter: hazmatValueGetter,
          cellRendererFramework: SpecialNeedsRenderer,
          cellRendererParams: {
            options: HZ_FILTER,
          },
          filterFramework: StaticFilter,
          filterParams: {
            staticOptions: HZ_FILTER,
          },
          minWidth: constants.columnWidth.HU,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
        },
        {
          headerName: "Cube",
          field: "cube",
          minWidth: constants.columnWidth.W_85,
          lockPosition: true,
          headerTooltip: "Cube",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Pro #",
          valueGetter: this.proIdValueGetter,
          headerTooltip: "ProNumber",
          minWidth: constants.columnWidth.PROID,
          lockPosition: true,
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "SVC",
          valueGetter: svcValueGetter,
          minWidth: constants.columnWidth.W_120,
          lockPosition: true,
          headerTooltip: "Service Level",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Trailer",
          minWidth: constants.columnWidth.TRAILER_ID,
          field: "trailer",
          lockPosition: true,
          headerTooltip: "Trailer",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
        },
      ],
    };
  }
}
